
export const REDUX_REDUCER_ADDED = 'it.lacele/REDUX_REDUCER_ADDED'
export const REDUX_REDUCER_REMOVED = 'it.lacele/REDUX_REDUCER_REMOVED'
export const REDUX_STATE_REMOVE = 'it.lacele/REDUX_STATE_REMOVE'
